'use strict';

import React, { Component, createRef } from 'react';
import uniqid from 'uniqid';
import SlickSlider from 'react-slick';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import Logo from 'Pure/Logo';
import truncate from 'Functions/truncate';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { etablishment as etablishment_icons } from 'Components/IconsConfigs';
import { action } from 'Shared/Routes';
import { etablishment_equipments } from 'Shared/options';
import isPartiallyinViewport from 'Functions/isPartiallyinViewport';
const {
  app,
  qwest
} = window;
const settings = {
  className: 'center',
  centerMode: true,
  centerPadding: '60px',
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  speed: 500,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 1
    }
  }]
};
export default class EtablishmentsSlider extends Component {
  state = {
    loading: false,
    ready: false,
    data: [],
    order: this.props['order'] || 'asc',
    order_by: this.props['order-by'] || 'name',
    width: window.innerWidth,
    title: this.props.title || 'Nos différents établissements'
  };
  ref = createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetch({});
    app.push({
      event: 'window.resize',
      cb: component.handleResize
    });
    if (isPartiallyinViewport(component.ref?.current)) {
      component.setState({
        ready: true
      });
    } else {
      window.setTimeout(component.readyTimeout, 500);
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'window.resize',
      cb: component.handleResize
    });
  }
  readyTimeout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.ready || !component.ref?.current) return;
    if (isPartiallyinViewport(component.ref.current)) {
      component.setState({
        ready: true
      });
    } else {
      window.setTimeout(component.readyTimeout, 500);
    }
  };
  handleResize = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (window.innerWidth !== state.width) {
      component.setState({
        width: window.innerWidth,
        render_id: uniqid()
      });
    }
  };
  fetch = ({
    searched,
    type,
    page
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllFrontEtablishments'), {
      source: 'front_slider'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        data: (response.data || []).map(function (data) {
          data.description = truncate(data.description, 160);
          return data;
        }),
        width: window.innerWidth,
        render_id: uniqid()
      });
      if (props.onFetch instanceof Function) {
        props.onFetch({
          data: response.data || []
        });
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      ready
    } = state;
    const modifiers = ['etablishment', 'slider'].concat(props.bemit || []);
    let etablishments = (ready ? state.data || [] : []).map(function (data, i) {
      let link = '/' + ['etablissements', data.slug].join('/');
      const icons = etablishment_equipments.filter(infos => (data.service || []).includes(infos.value)).map(function (infos) {
        const icons_info = etablishment_icons.find(data => data.value === infos.value);
        if (!icons_info) return null;
        const Icon = icons_info.icon;
        const output = /*#__PURE__*/React.createElement("div", {
          className: "c-media__icon",
          key: infos.value
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "c-media__icon-svg"
        }), /*#__PURE__*/React.createElement("div", {
          className: "u-readers-only"
        }, infos.label || infos.value));
        return output;
      });
      const city = data.address?.city;
      let output = /*#__PURE__*/React.createElement(Link, {
        className: bemit('c-media', modifiers),
        key: data.id,
        href: link
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__img-container"
      }, data.not_configured ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__color-label"
      }, "Ouverture prochaine") : undefined, data.images[0] ? /*#__PURE__*/React.createElement(Image, {
        className: "c-media__img",
        src: variant({
          img: data.images[0],
          size: 600
        }),
        alt: data.images[0]?.title || 'Photo du ' + data.name
      }) : /*#__PURE__*/React.createElement(Logo, {
        className: "c-media__img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "c-media__texts"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__title"
      }, data.name, city ? ' - ' + city : undefined), /*#__PURE__*/React.createElement("div", {
        className: "c-media__icons"
      }, icons))));
      return output;
    });
    const placeholders = etablishments.length > 0 ? undefined : [0, 1, 2].map(function (index) {
      const output = /*#__PURE__*/React.createElement("div", {
        className: bemit('c-media', modifiers),
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__img-container"
      })));
      return output;
    });
    const preloads = (ready ? [] : state.data || []).map(function (etablishment) {
      return /*#__PURE__*/React.createElement("link", {
        key: etablishment.id,
        rel: "preload",
        as: "image",
        href: variant({
          img: etablishment.images[0],
          size: 600
        })
      });
    });
    let output = /*#__PURE__*/React.createElement("section", {
      className: bemit('o-spaces-block', modifiers)
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__top"
    }, /*#__PURE__*/React.createElement("header", {
      className: "o-spaces-block__header"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "c-title"
    }, state.title))), /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__slider",
      ref: component.ref
    }, !ready || etablishments.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__slider-placeholder"
    }, placeholders, preloads) : /*#__PURE__*/React.createElement(SlickSlider, settings, etablishments)));
    return output;
  }
}
